import { useEffect } from "react";
import { createPortal } from "react-dom";

export const Modal = ({ isOpen, onClose, children, className = "" }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const content = (
    <div className="z-[40] fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center">
      <div
        className="z-[40] bg-slate-800/70 fixed top-0 left-0 right-0 bottom-0 absolute"
        onClick={onClose}
      />

      <div className="z-[41]">{children}</div>
    </div>
  );

  // Create portal
  return createPortal(content, document.body);
};
